var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#2255a1",
    viewBox: "0 0 432 432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m394 146-32-32 8-8c20-18 20-50 0-70-20-18-52-18-70 0l-8 8-32-32c-16-16-42-16-58 0L12 202c-16 16-16 42 0 58l134 134c16 16 42 16 58 0l190-190c16-16 16-42 0-58zm-82 10c2 2 6 2 8 0l8-6c0 2-2 6-4 8-4 6-12 6-16 0-4-4-4-10 0-14 4-2 6-4 10-4l-6 6c-2 4-2 8 0 10zm-4-110c16-14 38-14 52 0 16 14 16 38 0 52l-6 8-52-52 6-8zm-58 48c4 4 8 4 10 0l6-6c0 4 0 8-4 10-4 4-10 4-14 0s-4-12 0-16c2-2 6-4 8-2l-6 6c-2 2-2 6 0 8zm-54 292c-12 10-30 10-40 0L22 250c-12-10-12-28 0-40l20-20 174 176-20 20zm28-30L50 182 210 22c12-12 30-12 40 0l32 32-16 16c-8-6-20-4-28 4s-8 24 0 32c10 10 24 10 34 0 8-6 10-18 4-28l16-16 52 52-16 16c-10-4-20-4-28 4-10 10-10 24 0 34 8 10 24 10 34 0 6-8 8-20 4-28l16-16 32 32c10 10 10 28 0 40L224 356zm62-170c-2-4-4-6-8-6v2c-4 0-6 4-6 6s2 4 2 4c2 2 4 2 6 2 4-2 6-4 6-8zM92 290l24 24c2 4 6 4 10 0 2-2 2-6 0-8l-26-24c-2-4-6-4-8 0-4 2-2 6 0 8zm188-146c-2-4-4-6-8-6l-120 28c-4 0-6 4-6 6s2 4 2 4c2 2 4 2 6 2l120-28c4 0 6-4 6-6zm-150 32c0-2-4-6-8-4-4 0-6 4-6 8l2 2c2 2 4 2 6 2 4 0 6-4 6-8zm126 16c-2-2-4-6-8-4l-120 26c-4 2-6 4-6 8 2 2 2 2 2 4 2 2 4 2 6 2l120-28c4 0 6-4 6-8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffers);
export default __webpack_public_path__ + "static/media/Offers.315f1895adbdc6d2e4eb5a61162c6d27.svg";
export { ForwardRef as ReactComponent };